import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { iProfitERPService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'iProfitERPLogs',
  initialState: adapter.getInitialState({
    busy: false,
    logs: [],
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setLogs: (state, { payload }) => ({ ...state, logs: payload }),
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchAPILogs = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await iProfitERPService.fetchAPILogs(params);
    dispatch(slice.actions.setLogs(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchExceptionLogs = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await iProfitERPService.fetchExceptionLogs(params);
    dispatch(slice.actions.setLogs(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  fetchAPILogs,
  fetchExceptionLogs,
};

const selectors = {
  ...adapter.getSelectors((state) => state.iProfitERPLogs),
};

export { actions, selectors };

export default slice.reducer;
